import axios from "axios";
import { APIURL } from "../../../../APIHandler/APIURL"
import { Headers } from "../../../../APIHandler/HeaderAPI";
import { reloadHandler } from "../../../../utlis/utlis";
import { Admin_Create_Activities_failure, Admin_Create_Activities_request, Admin_Create_Activities_success } from "../../../Reducer/Admin/CreateActivities/CreateActivities";
import { GetActivitiesAPI } from "./GetActivities";
import { Edit_Activites_failure, Edit_Activites_request, Edit_Activites_success } from "../../../Reducer/Admin/CreateActivities/EditActivity";

export const AdminEditActivitiesAPI = (payload,seteditopen,setaddactivites,id,editid) => async (dispatch, getState) => {
    // const eventItemId=localStorage.getItem("eventItemId")
    const auth_token = localStorage.getItem("auth_token")
    dispatch(Edit_Activites_request())
    const admineventid = localStorage.getItem("admineventid")
 
    try {
        const { data } = await axios.post(`${APIURL.admingeteditactivity}/${editid}`, payload, {
            headers: {
                "host-url": Headers?.["host-url"],
                "language": Headers?.language,
               "event-slug":Headers?.["event-slug"],
                // "Content-type": "application/json",
                "Content-type": "application/x-www-form-urlencoded",
                Authorization: `Bearer ${auth_token}`
            },
        })
        seteditopen(false)
        setaddactivites(false)
        dispatch(Edit_Activites_success(data))
        if(id){

            dispatch(GetActivitiesAPI(id))
        }else{

            dispatch(GetActivitiesAPI(admineventid))
        }
    } catch (error) {
        reloadHandler(error?.response?.status)
        dispatch(Edit_Activites_failure(error?.response?.data))
    }
}


